
import React, { useEffect, useState } from "react";
import {Tab, Tabs } from 'react-bootstrap';  
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from "./admindashboard";
import EmployeeDoctorAppointment from "./employeeDoctorAppointment";

import EmployeeAppointments from "./employeeAppointments";
  function EmployeeAppointmentsTab() {

  const [activeTab, setActiveTab] = useState('lab-appointments');
  // const [selectedOrgcode, setSelectedOrgcode] = useState(orgcode);

  useEffect(() => {
  
  }, []);


  return (
    <div>
      <AdminDashboard />

<div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <Tabs
              id="employee-profile-tabs"
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="mb-3"
            >
              <Tab eventKey="lab-appointments" title="Lab Appointments">
              {activeTab === 'lab-appointments' && (
                <EmployeeAppointments/>
              )}
              </Tab>
        
          
          <Tab eventKey="doctor-appointments" title="Doctor Appointments">
      {activeTab === "doctor-appointments" && (
            <EmployeeDoctorAppointment/>
          )}
          </Tab>

            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default EmployeeAppointmentsTab;